export const GAMES = ["minecraft_java"];
export const CORES = ["vanilla", "paper", "leaf", "fabric", "forge", "neoforge"];
export const CORES_BY_GAME = {
    minecraft_java: ["vanilla", "paper", "leaf", "fabric", "forge", "neoforge"],
};
export const MINECRAFT_JAVA_VERSIONS = [
    // 1.21.x
    "1.21.4",
    "1.21.3",
    "1.21.2",
    "1.21.1",
    "1.21",
    // 1.20.x
    "1.20.6",
    "1.20.5",
    "1.20.4",
    "1.20.3",
    "1.20.2",
    "1.20.1",
    "1.20",
    // 1.19.x
    "1.19.4",
    "1.19.3",
    "1.19.2",
    "1.19.1",
    "1.19",
    // 1.18.x
    "1.18.2",
    "1.18.1",
    "1.18",
    // 1.17.x
    "1.17.1",
    "1.17",
    // 1.16.x
    "1.16.5",
    "1.16.4",
    "1.16.3",
    "1.16.2",
    "1.16.1",
    "1.16",
    // 1.15.x
    "1.15.2",
    "1.15.1",
    "1.15",
    // 1.14.x
    "1.14.4",
    "1.14.3",
    "1.14.2",
    "1.14.1",
    "1.14",
    // 1.13.x
    "1.13.2",
    "1.13.1",
    "1.13",
    // 1.12.x
    "1.12.2",
    "1.12.1",
    "1.12",
    // 1.11.x
    "1.11.2",
    "1.11.1",
    "1.11",
    // 1.10.x
    "1.10.2",
    "1.10.1",
    "1.10",
    // 1.9.x
    "1.9.4",
    "1.9.2",
    "1.9",
    // 1.8.x
    "1.8.9",
    "1.8.8",
    "1.8.7",
    "1.8.6",
    "1.8.5",
    "1.8.4",
    "1.8.3",
    "1.8",
    // 1.7.x
    "1.7.10",
    "1.7.9",
    "1.7.5",
    "1.7.2",
    // 1.6.x
    "1.6.4",
    "1.6.2",
    // 1.5.x
    "1.5.2",
];
export const GAME_VERSIONS = {
    minecraft_java: MINECRAFT_JAVA_VERSIONS,
};
export const JAVA_VERSIONS = [8, 11, 17, 21, 25];
export const SERVER_STATUSES = [
    "queued_install",
    "queued_start",
    "queued_stop",
    "queued_delete",
    "installing",
    "stopped",
    "starting",
    "running",
    "stopping",
    "deleting",
    "deleted",
    "failed",
];
/** Публичный адрес сервера: код поддомена читает антибот-прокси из SNI/Host handshake. */
export function joinAddress(code, baseDomain) {
    return `${code}.${baseDomain}`;
}
/** Алфавит для join-кодов (Crockford base32, без визуально похожих символов). */
export const JOIN_CODE_ALPHABET = "0123456789abcdefghjkmnpqrstvwxyz";
export const JOIN_CODE_LENGTH = 7;
